module.exports = __webpack_public_path__ + "static/no-peanuts-b0f21817aa60002c1633d1c2a2ef820e.png";